import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_22667_165824)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.5 8C0.5 3.584 4.084 0 8.5 0C12.916 0 16.5 3.584 16.5 8C16.5 12.416 12.916 16 8.5 16C4.084 16 0.5 12.416 0.5 8ZM7.5 9L12 4.5L13.5 6L7.5 12L4 8.5L5.5 7L7.5 9Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_22667_165824",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0.5)"
		})
	}) })]
});
export default SvgCheckCircle;
